/*eslint-disable */
import React, { Component } from "react";
import { Table, Grid, Icon, Button } from "semantic-ui-react";
import RateChartModal from "../../../components/vendorComponent/rateChartModal";
import ReadAxios from "../../../components/axiosComponent/read";
import { isEmpty } from "lodash";
import Name from "../../../components/vendorComponent/name";
import { translate } from "react-i18next";
import DeleteModal from "../../../components/common/deleteModal";
import EditRateChart from "../../../components/common/rateChartEdit";
import DeleteAxios from "../../../components/axiosComponent/delete";
import {
  successAlertDispatcher,
  warningAlertDispatcher,
  errorAlertDispatcher,
  infoAlertDispatcher,
} from "../../../redux/actions/alertAction";
import { connect } from "react-redux";
export class RatechartTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      vendorRateChart: [],
      deleteModalOpen: false,
      ratechart: false,
      edit: {},
    };
  }

  componentDidMount() {
    this.getVendorRateChart();
  }

  setDeafultValue = (masterRoute, deafultValue) => {
    console.log("search dropdown >>>>", deafultValue);
    ReadAxios({
      url: `${masterRoute}/${deafultValue}`,
    })
      .then((res) => {
        console.log(res.data.resultSet);
      })
      .catch((err) => console.log(err));
  };

  RateChartEditModal = async (rateChart = "") => {
    if (rateChart) {
      Promise.all([
        ReadAxios({ url: `consignorMaster/${rateChart.source}` }),
        ReadAxios({ url: `consigneeMaster/${rateChart.destination}` }),
        ReadAxios({ url: `vehicleTypeMaster/${rateChart.vehicle_type_id}` }),
      ]).then((response) => {
        console.log(response);
        let consignor = response[0];
        let consignee = response[1];
        let vehicle = response[2];
        let data = Object.assign(
          {},
          {
            ...rateChart,
            ...consignor.data.resultSet[0],
            ...consignee.data.resultSet[0],
            ...vehicle.data.resultSet[0],
          }
        );
        this.setState(
          {
            ratechart: true,
            // data: data
            edit: data,
          },
          () => console.log("set staet rate")
        );
      });
    } else {
      this.setState({
        ratechart: true
      })
    }
  };

  RateChartEditModalClose = () => {
    this.setState({ ratechart: false });
  };
  openDeleteModal = (rateChart = {}) => {
    this.setState({ deleteModalOpen: true, edit: rateChart });
  };
  closeDeleteModal = () => {
    this.setState({ deleteModalOpen: false });
  };
  confirmDelete = () => {
    console.log("delete row");
    DeleteAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API_TWO}/vendor/rate/${this.state.edit.vendor_rate_id}`,
    })
      .then((res) => {
        let alert = {
          type: "success",
          messageHeader: "Success",
          messageBody: "Vendor rate deleted.",
        };
        console.log(res);
        this.props.successAlertDispatcher(alert);
        this.closeDeleteModal();
        this.getVendorRateChart();
      })
      .catch((err) => {
        let alert = {
          type: "error",
          messageHeader: "Error",
          messageBody: "Unable to delete vendor rate.",
        };
        console.log(err);
        this.props.errorAlertDispatcher(alert);
        this.closeDeleteModal();
      });
  };

  getVendorRateChart = () => {
    ReadAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API_TWO}/vendor/rate/${this.props.vendorId}`,
    })
      .then((res) => {
        isEmpty(res.data.resultSet)
          ? this.setState({ vendorRateChart: [] })
          : this.setState({ vendorRateChart: res.data.resultSet });
      })
      .catch((err) => {
        this.setState({ vendorRateChart: [] });
      });
  };

  updatePage = () => {
    this.RateChartEditModalClose();
    this.getVendorRateChart();
  };

  render() {
    const { t } = this.props;
    return (
      <>
        {true && (
          <div>
            <Table stackable size="small" selectable>
              <Table.Header className="w3-small">
                <Table.Row>
                  <Table.HeaderCell colSpan="7" className="p-bold-600">
                    {t('title')}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-600" textAlign="right">
                    <Button
                      type="button"
                      className="w3-button w3-blue w3-small w3-round w3-hover-blue"
                      onClick={() => this.RateChartEditModal()}
                    >
                      <Icon name="plus" /> {t('add_title')}
                    </Button>
                  </Table.HeaderCell>
                </Table.Row>
                <Table.Row>
                  <Table.HeaderCell className="p-bold-500">
                    {t("table_header.source")}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-500">
                    {t("table_header.destination")}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-500">
                    {t("table_header.vehicle_type")}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-500">
                    {t("table_header.freight_rate")}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-500">
                    {t("table_header.start_date")}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-500">
                    {t("table_header.end_date")}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-500">
                    {t("table_header.edit")}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-500">
                    {t("table_header.delete")}
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              {this.state.vendorRateChart.length > 0 ? (
                <>
                  <Table.Body>
                    {this.state.vendorRateChart.map((rateChart, index) => (
                      <Table.Row key={index}>
                        <Table.Cell>
                          <Name
                            url={"consignorMaster"}
                            id={rateChart.source}
                            keyIndex={"consignorName"}
                          />
                        </Table.Cell>
                        <Table.Cell>
                          <Name
                            url={"consigneeMaster"}
                            id={rateChart.destination}
                            keyIndex={"consigneeName"}
                          />
                        </Table.Cell>
                        <Table.Cell>
                          <Name
                            url={"vehicleTypeMaster"}
                            id={rateChart.vehicle_type_id}
                            keyIndex={"vehicleType"}
                          />
                        </Table.Cell>
                        <Table.Cell>{rateChart.freight_rate}</Table.Cell>
                        <Table.Cell>{rateChart.start_date}</Table.Cell>
                        <Table.Cell>{rateChart.end_date}</Table.Cell>
                        <Table.Cell>
                          <Button
                            type="button"
                            onClick={() => this.RateChartEditModal(rateChart)}
                            size="mini"
                            color="green"
                            basic
                            icon
                          >
                            {" "}
                            <Icon name="edit" />{" "}
                          </Button>{" "}
                        </Table.Cell>
                        <Table.Cell>
                          <Button
                            type="button"
                            onClick={() => this.openDeleteModal(rateChart)}
                            size="mini"
                            color="blue"
                            basic
                            icon
                          >
                            {" "}
                            <Icon name="trash" />{" "}
                          </Button>
                        </Table.Cell>
                      </Table.Row>
                    ))}
                  </Table.Body>
                </>
              ) : (
                <div style={{ textAlign: "center", padding: "5px", width: "100%" }}>
                  <p>No Records Found</p>
                </div>
              )}

            </Table>
          </div>
        )}
        <DeleteModal
          deleteOpen={this.state.deleteModalOpen}
          CloseModal={this.closeDeleteModal}
          ConfirmDeleteRow={this.confirmDelete}
        />
      </>
    );
  }
}

export default connect(null, {
  successAlertDispatcher,
  warningAlertDispatcher,
  errorAlertDispatcher,
  infoAlertDispatcher,
})(translate('rate_chart')(RatechartTable));
